import React from 'react';
import PropTypes from 'prop-types';
import toSnakeCase from '../../../../helpers/to_snake_case';
import '../../../../../sass/apps/commerce/mobile/tiled_variation/product_selector.scss';
import '../../../../../sass/components/forms.scss';

const displayNames = new Map([
  ['1 week', '7 days'],
  ['2 weeks', '14 days'],
  ['4 weeks', '28 days'],
]);

const TiledProductSelector = ({
  currencySymbol,
  currentProduct,
  products,
  updateCart,
  experiments,
  localisations
}) => {
  function selectProduct(product) {
    updateCart(product);
  }
  const productRows = products.map((product) => (
    <ProductRow
      key={product.id}
      product={product}
      selected={currentProduct.id == product.id}
      selectProduct={selectProduct}
      currencySymbol={currencySymbol}
      currentProduct={currentProduct}
      localisations={localisations}
    />
  ));
  return (
    <form
      role="group"
      aria-labelledby="product-selector-heading"
      className="product-selector"
    >
      {productRows}
    </form>
  );
};

const ProductRow = ({
  product,
  currencySymbol,
  currentProduct,
  selected,
  selectProduct,
  localisations
}) => {
  const selectedClass = selected ? ' product-selector__product--selected' : '';
  const itemClassName = `product-selector__product${selectedClass}${` product-selector__product--${toSnakeCase(
    product.name,
  )}`}`;
  const originalPrice = product.original_price ? (
    <div className="product-selector__original-price">
      <span className="product-selector__price-symbol">{currencySymbol}</span>
      <span className="price">{product.original_price}</span>
    </div>
  ) : null;
  return (
    <div className={itemClassName}>
      <div
        onClick={() => selectProduct(product)}
        className="product-selector__most-popular"
      >
        {localisations.most_popular}
      </div>
      <label className="product-selector__label" htmlFor={product.id}>
        <div className="form-group__radio">
          <input
            type="radio"
            onChange={() => selectProduct(product)}
            id={product.id}
            name="product"
            value={product.id}
            checked={product.id == currentProduct.id}
          />
          <span className="form-group__label">
            <span className="product-selector__name">{product.duration}</span>
          </span>
        </div>
        {originalPrice}
        <div className="product-selector__price">
          <span className="product-selector__price-symbol">
            {currencySymbol}
          </span>
          {product.price}
        </div>
      </label>
    </div>
  );
};

TiledProductSelector.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  currentProduct: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  updateCart: PropTypes.func.isRequired,
};

export default TiledProductSelector;
